module.exports = __webpack_public_path__ + "static/img/online_02.ff93abf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/recruit_2022/corona/online_02.png
// module id = lEYl
// module chunks = 0